import { Pipe, PipeTransform } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { Observable, map, of } from 'rxjs';
@Pipe({
  name: 'hasRoles',
  standalone: true,
})
export class HasRolesPipe implements PipeTransform {
  constructor(public auth: AuthService) {}
  transform(requiredRoles: string[], ..._args: unknown[]): Observable<boolean> {
    if (requiredRoles.length == 0) {
      return of(true);
    }
    return this.auth.user$.pipe(
      map((user) => {
        if (user) {
          const userRoles = user['https://thred.cloud/roles'];
          if (
            userRoles &&
            requiredRoles.some((role) => {
              return userRoles.includes(role);
            })
          ) {
            return true;
          }
        }
        return false;
      }),
    );
  }
}
